'use strict';

var getPolyfill = require('./polyfill');
var define = require('define-properties');

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/object.values/shim.js
 ** module id = 1147
 ** module chunks = 0
 **/